import { faComments } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const FaqCard = ({post}) => {
    return (
        <div className="col-md-4 mt-5 mb-5" style={{width: '18rem',}}>
            <FontAwesomeIcon icon={faComments} size="2x" className="mb-3"/>
            <div className="card-body d-flex justify-content-center flex-column" style={{background: 'whitesmoke', borderRadius: '10px', height: '15rem'}}>
                <h5 className="card-title text-color"><b>{post.title}</b></h5>
                <p className="card-text">{post.content}</p>
            </div>
        </div>
    );
};

export default FaqCard;